import React from "react";
import { Form, Button, ButtonGroup } from 'reactstrap';
import { withNavigation } from '../Components/helpers/withNavigation';
import '../App.css';
import {v4 as uuid} from 'uuid';
import './MainAccordion.css';
import '../Components/layout/layout.css';
import PromptModal from '../Components/helpers/PromptModal';
import { TourProvider } from '@reactour/tour';
import { TourBridge, SkipHiddenTourSteps } from '../utils/TourHelpers';

function CreateCheckListWithTour(props){
  const steps= [
    {
      selector:'.function-bar',
      content:(
      <>
        <li>Home makes the app go back to selecting trainings on the homepage, where you can choose between trainings you have created to view, edit, or export.</li>
        {!props.supportsFSAccess && (
          <li>Click Download Backup to save a copy of your data (your browser will download a file)</li>
        )}
        <li>Help to show this tour again.</li>
      </>
      ),
    },
    {
      selector: '.training-list',
      content:(
        <>
          <li>This is your list of steps.</li>
          <li>Swipe left, right click, or control + click (on mac) on a step to see more options like Edit or Delete.</li>
          <li>Select Reorder Steps to show arrows to reorder steps.</li>
        </>
      ),
    },{
      selector: '.checklist-controls',
      content:(
        <>
          <li>This is the control area for managing your checklist.</li>
          <li>Use the buttons to add steps, reorder them, or create a training from the checklist.</li>
        </>
        ),
    }
  ]
  return (
    <div className={'training-container'}>
      <TourProvider 
        steps={steps} 
        showBadge={false}
        padding={10} 
        scrollSmooth 
        className="my-custom-tour" 
        onClickClose={() => {props.updateState({showTour: false});}} 
        onClickMask={() => {props.updateState({showTour: false});}} 
      >
        <SkipHiddenTourSteps/>
        <TourBridge showTour={props.showTour} incognitoBrowser={props.incognitoBrowser} updateState={props.updateState}>
          <CreateCheckList {...props} />
        </TourBridge>
      </TourProvider>
    </div>
  );
}

class CreateCheckList extends React.Component {
  constructor(props) {
    super(props);
        
    const saveMessage = {
      icon:'success',
      title:'Progress Saved',
      label: '',
      message: '',
      duration: 3000
    };

    this.state = {
      swipedId: null,
      showPrompt: false,
      modalTitle: '',
      newStepTitle: '',
      newStepDetails: '',
      draggingId: null,
      dragStartX: null,
      dragStartSwipedId: null,
      saveMessage: saveMessage
    };
  }

  componentDidMount() {
    // Add delegation listeners to catch events from all items, even those outside viewport
    document.addEventListener('pointerdown', this.handleDelegatedPointerDown, true);
    document.addEventListener('pointermove', this.handleDelegatedPointerMove, true);
    document.addEventListener('pointerup', this.handleDelegatedPointerUp, true);
  }

  componentWillUnmount() {
    document.removeEventListener('pointerdown', this.handleDelegatedPointerDown, true);
    document.removeEventListener('pointermove', this.handleDelegatedPointerMove, true);
    document.removeEventListener('pointerup', this.handleDelegatedPointerUp, true);
  }

  handleDelegatedPointerDown = (e) => {
    const item = e.target.closest('.step-item');
    if (!item) return;
    
    const id = this.getItemIdFromElement(item);
    if (!id) return;
    
    this.handleTouchStart(id, e);
  }

  handleDelegatedPointerMove = (e) => {
    const item = e.target.closest('.step-item');
    if (!item) return;
    
    const id = this.getItemIdFromElement(item);
    if (!id) return;
    
    this.handleTouchMove(id, e);
  }

  handleDelegatedPointerUp = (e) => {
    const item = e.target.closest('.step-item');
    // if (!item) return;
    
    const id = item ? this.getItemIdFromElement(item) : null;
    // if (!id) return;
    
    this.handleTouchEnd(id, e);
  }

  getItemIdFromElement = (element) => {
    // Extract the item ID from the step-item element
    // Assumes item index is available in the data or by finding it in the checklist
    const text = element.textContent;
    const match = text.match(/^\d+\.\s+(.+)$/);
    if (!match) return null;
    
    const stepTitle = match[1];
    const item = this.props.currentTraining?.CheckList?.find(i => i.Step === stepTitle);
    return item?.Id || null;
  }

  handleTouchStart = (Id, e) => {
    // console.log("Touch start on item:", Id, " event:", e);
    if(this.state.reordering){ return;}
    
    // Capture pointer to ensure events continue to fire even during scroll
    if (e.type === "pointerdown" && e.target.setPointerCapture) {
      try {
        e.target.setPointerCapture(e.pointerId);
      } catch (err) {
        console.warn("setPointerCapture failed:", err);
      }
    }
    
    const startX = e.clientX || (e.touches && e.touches[0]?.clientX);
    
    if ((e.type === "touchstart" || e.type === "pointerdown") && (e.touches?.length === 1 || e.isPrimary)) {
      this.setState({
        dragStartX: startX,
        draggingId: Id,
        dragStartSwipedId: this.state.swipedId,
      });
    } else if (e.type === "mousedown") {
      this.setState({
        dragStartX: e.clientX,
        draggingId: Id,
        dragStartSwipedId: this.state.swipedId,
      });
    }
  };

  handleTouchMove = (Id, e) => {
    if (this.state.draggingId) {
      const currentX = e.clientX ?? (e.touches && e.touches[0]?.clientX);
      const deltaX = currentX - this.state.dragStartX;
      // Detect horizontal drag for swipe
      const item = e.target.closest('.step-item');
      const width = item ? item.offsetWidth : window.innerWidth;
      if(Math.abs(deltaX) > width / 10) {
        if (deltaX < 0 && !this.state.swipedId)
          this.setState({ swipedId: this.state.draggingId });
        if(deltaX > 0 && this.state.swipedId) 
          this.setState({ swipedId: null });
      }else{
        this.setState({ swipedId: this.state.dragStartSwipedId });
      }
    }
  }

  handleTouchEnd = (Id, e) => {
      // Release pointer capture
      if (e.type === "pointerup" && e.target.releasePointerCapture) {
        try {
          e.target.releasePointerCapture(e.pointerId);
        } catch (err) {
          console.warn("releasePointerCapture failed:", err);
        }
      }
      
      this.setState({
        dragStartX: null,
        draggingId: null,
        dragStartSwipedId: null
      });
  }

  moveUp = (item) => {
    const list = [...this.props.currentTraining.CheckList];
    const idx = list.findIndex(i => i.Id === item.Id);
    if (idx > 0) {
      [list[idx - 1], list[idx]] = [list[idx], list[idx - 1]];
      
      // Update steps to match new order
      var steps = this.props.currentTraining.Steps;
      var movedCheckListStep = steps.find(s => s.StepType === 3 && s.Step === item.Index);
      var movedVideoModelStep = steps.find(s => s.StepType === 4 && s.Step === item.Index);
      var otherCheckListStep = steps.find(s => s.StepType === 3 && s.Step === item.Index - 1);
      var otherVideoModelStep = steps.find(s => s.StepType === 4 && s.Step === item.Index - 1);
      const movedSpaces = (movedCheckListStep ? 1 : 0) + (movedVideoModelStep ? 1 : 0);
      const otherSpaces = (otherCheckListStep ? 1 : 0) + (otherVideoModelStep ? 1 : 0);
      if (movedCheckListStep){
         movedCheckListStep.Step = list[idx].Index;
         movedCheckListStep.Index -= otherSpaces;
      }
      if (movedVideoModelStep) {
        movedVideoModelStep.Step = list[idx].Index;
        movedVideoModelStep.Index -= otherSpaces;
      }
      if (otherCheckListStep){
        otherCheckListStep.Step = item.Index;
        otherCheckListStep.Index += movedSpaces;
      }
      if (otherVideoModelStep){ 
        otherVideoModelStep.Step = item.Index;
        otherVideoModelStep.Index += movedSpaces;
      }

      // Re-index
      list.forEach((it, i) => it.Index = i + 1);
      const currentTraining = {...this.props.currentTraining, CheckList: list, Steps: steps.sort((a,b) => a.Index - b.Index)};
      this.props.updateState({currentTraining: currentTraining});
    }
  };

  moveDown = (item) => {
    const list = [...this.props.currentTraining.CheckList];
    const idx = list.findIndex(i => i.Id === item.Id);
    if (idx < list.length - 1) {
      [list[idx], list[idx + 1]] = [list[idx + 1], list[idx]];

      // Update steps to match new order
      var steps = this.props.currentTraining.Steps;
      var movedCheckListStep = steps.find(s => s.StepType === 3 && s.Step === item.Index);
      var movedVideoModelStep = steps.find(s => s.StepType === 4 && s.Step === item.Index);
      var otherCheckListStep = steps.find(s => s.StepType === 3 && s.Step === item.Index + 1);
      var otherVideoModeStep = steps.find(s => s.StepType === 4 && s.Step === item.Index + 1);
      const movedSpaces = (movedCheckListStep ? 1 : 0) + (movedVideoModelStep ? 1 : 0);
      const otherSpaces = (otherCheckListStep ? 1 : 0) + (otherVideoModeStep ? 1 : 0);
      if (movedCheckListStep){
         movedCheckListStep.Step = list[idx].Index;
         movedCheckListStep.Index += otherSpaces;
      }
      if (movedVideoModelStep) {
        movedVideoModelStep.Step = list[idx].Index;
        movedVideoModelStep.Index += otherSpaces;
      }
      if (otherCheckListStep){
        otherCheckListStep.Step = item.Index;
        otherCheckListStep.Index -= movedSpaces;
      }
      if (otherVideoModeStep){ 
        otherVideoModeStep.Step = item.Index;
        otherVideoModeStep.Index -= movedSpaces;
      }

      // Re-index
      list.forEach((it, i) => it.Index = i + 1);
      const currentTraining = {...this.props.currentTraining, CheckList: list, Steps: steps.sort((a,b) => a.Index - b.Index)};
      this.props.updateState({currentTraining: currentTraining});
    }
  };

  handleEdit = (item) => {
    this.setState({
      showPrompt: true,
      modalTitle: 'Edit Step ' + item.Index,
      newStepTitle: item.Step,
      newStepDetails: item.SubSteps || ""
    });
  }

  handleDelete = (item) => {
    if (window.confirm(`Are you sure you want to delete step: ${item.Step}?`)) {
      const list = this.props.currentTraining.CheckList.filter(t => t.Id !== item.Id);
      const steps = this.props.currentTraining.Steps.filter(s => !(s.Step === item.Index && (s.StepType === 3 || s.StepType === 4)));
      const removedSteps = this.props.currentTraining.Steps.length - steps.length;
      for (let i = item.Index + 1; i <= this.props.currentTraining.CheckList.length; i++) {
        const clItem = list.find(c => c.Index === i);
        if (clItem) clItem.Index -= 1;  
        const clStep = steps.find(s => s.Step === i && s.StepType === 3);
        if (clStep) clStep.Step -= 1;
        const vmStep = steps.find(s => s.Step === i && s.StepType === 4);
        if (vmStep) vmStep.Step -= 1;
        if (clStep) clStep.Index -= removedSteps;
        if (vmStep) vmStep.Index -= removedSteps;
      }
      const conclusionSteps = steps.filter(s => s.StepType === 2 && s.Index > removedSteps[0].Index);
      conclusionSteps?.forEach(s => s.Index -= removedSteps);
      const currentTraining = {...this.props.currentTraining, CheckList: list, Steps: steps};

      this.props.updateState(currentTraining, () => {
        this.setState({ swipedId: null });
      });
    }
  }

  handleAddStep = () => {
    this.setState({
      showPrompt: true,
      modalTitle: 'Add a New Step',
      newStepTitle: `New Step ${this.props.currentTraining.CheckList.length + 1}`,
      newStepDetails: "",
      swipedId: null
    });
  }

  handleSaveStep = ({ title, details }) => {
    this.setState({ showPrompt: false });
    if (!title) return;
    if (title.trim() === "") {
      alert("Step description cannot be empty.");
      return;
    }
    if (this.state.modalTitle.includes("Add")) {
      const newId = uuid();
      const newIndex = this.props.currentTraining.CheckList.length ? Math.max(...this.props.currentTraining.CheckList.map(t => t.Index)) + 1 : 1;
      const newCheckListItem = {
        Id: newId,
        Index: newIndex,
        Step: title.trim(),
        SubSteps: details.trim()
      };
      const steps = [...this.props.currentTraining.Steps];
      steps.forEach(s => {
        if (s.Step >= newIndex) {
          s.Step += 1;
        }
      });
      this.props.updateState((prev) => ({
        currentTraining: {
          ...prev.currentTraining,
          CheckList: [...prev.currentTraining.CheckList, newCheckListItem],
          Steps: steps
        }
      }));
    }
    if (this.state.modalTitle.includes("Edit") && this.state.swipedId) {
      var checklist = [...this.props.currentTraining.CheckList];
      var idx = checklist.findIndex(i => i.Id === this.state.swipedId);
      var steps = [...this.props.currentTraining.Steps];
      var stepIdx = steps.findIndex(s => s.StepType === 3 && s.Step === checklist[idx].Index);
      var videoIdx = steps.findIndex(s => s.StepType === 4 && s.Step === checklist[idx].Index);
      if (idx >= 0) {
        checklist[idx] = { ...checklist[idx], Step: title.trim(), SubSteps: details.trim() };
        if(stepIdx >= 0)
          steps[stepIdx] = { ...steps[stepIdx], Title: title.trim() };
        if(videoIdx >= 0)
          steps[videoIdx] = { ...steps[videoIdx], Title: title.trim() };
        const currentTraining = {...this.props.currentTraining, CheckList: checklist, Steps: steps};
        this.props.updateState({currentTraining: currentTraining});
      }
      this.setState({ swipedId: null });
    }
  };

  handleCreateTraining = () => {
    if (!this.props.currentTraining.CheckList || this.props.currentTraining.CheckList.length === 0) {
      alert("CheckList is empty. Please add steps before creating a training.");
      return;
    }
    var introductionStep = this.props.currentTraining?.Steps?.find(step => step.StepType === 2 && step.InfoSlideType === 1);
    if (!introductionStep) {
      introductionStep = {
        id: uuid(),
        Index: 0,
        Title: this.props.currentTraining?.Title,
        Information: '',
        StepType: 2,
        InfoSlideType: 1,
      };
    }
    const currentStep = introductionStep;
    this.props.updateState({currentStep, tempMessage: this.state.saveMessage});
    const curURL = new URL(window.location.href);
    this.props.navigate({
      pathname: '/information-step',
      search: curURL.search
    });
  }

  render() {
    if(!this.props.currentTraining){
      return (<div><p>No training selected.</p></div>);
    }
    const createTrainingDisabled = !this.props.currentTraining || !this.props.currentTraining.CheckList || this.props.currentTraining.CheckList.length === 0;
    return (
      // <div className="training-container">
      <div>
        <Form id='main-form' className='main-form'>
          <legend className="instruct-checklist-title">{this.props.currentTraining?.Title}</legend>
          <div className="training-list">
          {(this.props.currentTraining?.CheckList && this.props.currentTraining.CheckList.length > 0) ? this.props.currentTraining.CheckList.map(item => (
            <div
              key={item.Id}
              className={`step-item ${this.state.swipedId === item.Id || this.state.reordering ? 'swiped' : ''}`}
              onContextMenu={(e) => {
                e.preventDefault(); // prevent default right-click menu
                if (item.Id === this.state.swipedId) {
                  this.setState({ swipedId: null });
                } else {
                  this.setState({ swipedId: item.Id });
                }
              }}
            >
              <div className="step-content">
                {(item.Index) + " | " + item.Step}
                {item.SubSteps && (
                  <div className="substeps-box">
                    {item.SubSteps.split('\n').map((line, idx) => (
                      <div key={idx}>{line}</div>
                    ))}
                  </div>
                )}
              </div>
              {this.state.swipedId === item.Id && (
                <div className="step-actions">
                  <Button color="success" onClick={(e) => { e.stopPropagation(); this.handleEdit(item); }}>Edit</Button>
                  <Button color="danger" onClick={(e) => { e.stopPropagation(); this.handleDelete(item); }}>Delete</Button>
                </div>
              )}
              {this.state.reordering && (
                <div className="step-actions">
                  <Button
                    color="primary"
                    disabled={item.Index <= 1}
                    onClick={(e) => { e.stopPropagation(); this.moveUp(item); }}
                    title="Move Up"
                  >
                    &#8593; {/* Up arrow */}
                  </Button>
                  <Button
                    color="primary"
                    disabled={item.Index >= this.props.currentTraining.CheckList.length}
                    onClick={(e) => { e.stopPropagation(); this.moveDown(item); }}
                    title="Move Down"
                  >
                    &#8595; {/* Down arrow */}
                  </Button>
                </div>
              )}
            </div>
          )) :
            (
              <div className="no-steps">No steps in checklist. Click "Add Step to CheckList" to create one.</div>
            )}
        </div>
        </Form>
        <PromptModal
          isOpen={this.state.showPrompt}
          showAlert={this.props.currentTraining && this.props.currentTraining.CheckList.length >= 5}
          title={this.state.modalTitle}
          defaultTitle={this.state.newStepTitle}
          defaultDetails={this.state.newStepDetails}
          onCancel={() => this.setState({ showPrompt: false })}
          onSubmit={this.handleSaveStep}
        />
        <div className="checklist-controls">
          <ButtonGroup className='instruct-control-bar' size='lg'>
            <Button className='instruct-control-button' onClick={this.handleAddStep}>Add Step to CheckList</Button>
            <Button className='instruct-control-button' disabled={createTrainingDisabled} onClick={() => this.setState(prev => ({ reordering: !prev.reordering, swipedId: null }))}>{this.state.reordering ? 'Done Reordering' : 'Reorder Steps'}</Button>
            <Button className='instruct-control-button' color="primary" disabled={createTrainingDisabled} onClick={this.handleCreateTraining}>Create Training from CheckList</Button>
          </ButtonGroup>
        </div>
      </div>
    );
  }
}
export default withNavigation(CreateCheckListWithTour);
